module.exports = __webpack_public_path__ + "static/media/semiconductors_5_desktop.1e6b20df.jpg";